import { NotificationProvider } from "@/react/components/shared/uikit/HeaderV3/RightActionBlock/Notifications/NotificationContext";
import { ModalManagerProvider } from "@circle-react/components/Layout/ModalManagerProvider";
import {
  ChatRoomsContextProvider,
  UnreadChatThreadsProvider,
} from "@circle-react/hooks/chatsV2";
import { OtpChallengeProvider } from "../contexts/OtpChallengeContext";
import { MasqueradeContextProvider } from "../contexts/masqueradeContext";
import { SpaceNotificationsProvider } from "../contexts/sidebarNotificationsContext";

const Providers = [
  ChatRoomsContextProvider,
  SpaceNotificationsProvider,
  UnreadChatThreadsProvider,
  ModalManagerProvider,
  MasqueradeContextProvider,
  NotificationProvider,
  OtpChallengeProvider,
];

export const MultiContextProvider = ({ children }: any) =>
  Providers.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    children,
  );
